/**
 * @file Contributor dashboard UI — pages/Dashboard/Contributor/types/contributorStageNames.ts.
 */

export const BASE_STAGES = [
  "Contributor's Details",
  "Publication Details",
  "Background Data",
] as const;

/** Type definition — Stage Name. */
export type StageName =
  | (typeof BASE_STAGES)[number]
  | "A1"
  | "A2"
  | "A3"
  | "A1-A3"
  | "Dataset"
  | "Submitted Dataset";
